import type { TMessages } from '@/types/TMessages'

export const messages = {
  subtitle: 'Вам доступно до 5 отчётов по оценке полей',
} satisfies TMessages
